// /src/jsx/components/MedicalInfoSection/index.jsx
import React from "react";
import { Row } from "react-bootstrap";
import { useLocalization } from "../../../context/LocalizeContextProvider";
import PillItem from "../PillItem";
import { CardItemFile } from "../UploadFileField";
import styles from "./MedicalInfoSection.module.css";

const WrapperInformation = ({ label = "", value }) => {
  const isJsx = typeof value === "object" && value !== null;

  return (
    <div className={styles.informationWrapper}>
      <p className={styles.infoLabel}>{label}</p>
      {isJsx ? value : <p className={styles.infoValue}>{value || "-"}</p>}
    </div>
  );
};

const MedicalInfoSection = ({
  doctorName = "",
  anamnesis = "",
  physicalExamination = "",
  diagnoses = [],
  uploadedFiles = [],
  onClickDetail = () => undefined,
  showDetailLink = true,
  className = "",
}) => {
  const localize = useLocalization();

  return (
    <div className={`${styles.medicalInfo} ${className}`}>
      <div className={styles.medicalInfoHeader}>
        <p className={styles.sectionTitle}>
          {localize.getText("medicalInformation")}
        </p>
        {showDetailLink && (
          <p className={styles.detailLink} onClick={onClickDetail}>
            {localize.getText("examinationDetail")}
          </p>
        )}
      </div>

      <WrapperInformation
        label={localize.getText("doctor")}
        value={doctorName}
      />

      <WrapperInformation
        label={localize.getText("anamnesia")}
        value={anamnesis}
      />

      <WrapperInformation
        label={localize.getText("examination")}
        value={physicalExamination}
      />

      <WrapperInformation
        label={localize.getText("diagnosis")}
        value={
          diagnoses.length > 0 ? (
            <div className={styles.diagnosisContainer}>
              {diagnoses.map((diagnosis, index) => (
                <PillItem key={index} text={diagnosis} />
              ))}
            </div>
          ) : (
            <p className={styles.emptyText}>
              {localize.getText("noDiagnosis")}
            </p>
          )
        }
      />

      <WrapperInformation
        label={`${localize.getText("recipe")}/${localize.getText(
          "uploadedFiles"
        )}`}
        value={
          uploadedFiles.length > 0 ? (
            <Row className={styles.filesRow}>
              {uploadedFiles.map((file, index) => (
                <CardItemFile
                  fileUpload={{ name: file, preview: file }}
                  md={4}
                  key={index}
                  isView
                />
              ))}
            </Row>
          ) : (
            <p className={styles.emptyText}>
              {localize.getText("noUploadedFiles")}
            </p>
          )
        }
      />
    </div>
  );
};

export default MedicalInfoSection;
